export default {
  screen: {
    //  Pixels
    XS: 480, // Small Mobile
    SM: 576, // Mobile
    MD: 768, // Tablet
    LG: 992, // Laptop
    XL: 1200, // Desktop
    XXL: 1600, // Large Desktop
  },

  font: {
    //  Pixels
    XS: 14,
    SM: 16,
    MD: 18,
    LG: 20,
    XL: 24,
    XXL: 28,
  },
};
